import React, { FunctionComponent, useContext, useEffect, useMemo } from "react";
import { Theme, makeStyles, Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { NutritionContext } from "../../context/nutrition-context";
import { useNutrientsToDecreaseLazyQuery } from "../../../../api/smartmelts-api/graphql/generated";
import { QuestionSectionLoadingIndicator } from "../../question/question-section-loading-indicator";
import { NutrientIndicator } from "../../answer/nutrient-indicator/nutrient-indicator";
import lodash from "lodash";
import { HeadingText } from "../../../../components/text/heading-text";
import { ContentText } from "../../../../components/text/content-text";
import { NutrientsDecreaseIcon } from "../../../../assets/icons/nutrients/nutrients-decrease-icon";
import { NUTRIENT_CONSUMPTION_ICON_SIZE } from "../../../../theme/theme";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    flex: 1,
    width: "100%",
  },
  titleIcon: {
    marginLeft: theme.spacing(2),
  },
  contentContainer: {
    marginTop: theme.spacing(2),
  },
  cardsContainer: {
    marginTop: theme.spacing(2),
    padding: "0 !important",
  },
}));

interface INutrientsToDecreaseProps {}

export const NutrientsToDecrease: FunctionComponent<INutrientsToDecreaseProps> = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { isDemo, scrollTop } = useContext(NutritionContext);

  const [nutrientsToDecreaseQuery, { loading, data }] = useNutrientsToDecreaseLazyQuery({
    onCompleted: () => scrollTop(),
  });

  useEffect(() => {
    nutrientsToDecreaseQuery({ variables: { demo: isDemo } });
  }, [nutrientsToDecreaseQuery, isDemo]);

  const nutrients = useMemo(() => lodash.orderBy(data?.nutrientsToDecrease, (item) => +item.value, "asc"), [
    data?.nutrientsToDecrease,
  ]);

  return (
    <Grid container className={classes.container}>
      <HeadingText>
        <Grid container item alignItems={"center"}>
          {t(`nutrients_to_decrease.heading`)}
          <NutrientsDecreaseIcon
            width={NUTRIENT_CONSUMPTION_ICON_SIZE}
            height={NUTRIENT_CONSUMPTION_ICON_SIZE}
            className={classes.titleIcon}
          />
        </Grid>
      </HeadingText>
      <Grid container direction="column">
        <Grid item className={classes.contentContainer}>
          <ContentText light>{t(`nutrients_to_decrease.subheading`)}</ContentText>
        </Grid>
        {!loading && data?.nutrientsToDecrease && (
          <Grid container spacing={4} item className={classes.cardsContainer}>
            {nutrients.map((nutrient, index) => (
              <Grid item xs={12} md={6} key={index}>
                <NutrientIndicator nutrient={nutrient} />
              </Grid>
            ))}
          </Grid>
        )}
        {loading && <QuestionSectionLoadingIndicator />}
      </Grid>
    </Grid>
  );
};
